import { render, staticRenderFns } from "./NetworkStreamax.vue?vue&type=template&id=0cf8fd6b&scoped=true&"
import script from "./NetworkStreamax.vue?vue&type=script&lang=ts&"
export * from "./NetworkStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./NetworkStreamax.vue?vue&type=style&index=0&id=0cf8fd6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf8fd6b",
  null
  
)

export default component.exports